export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BackToTopButton.vue?vue&type=template&id=3566afd3&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/BackToTopButton.vue?vue&type=template&id=3566afd3&
// module id = 195
// module chunks = 0